import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function NoticeFormsRoute() {

    const { path } = useRouteMatch();
    
    return (
        <Switch>
            <Route path={`${path}`} exact>
                <Pages.NoticeAlarmPage />
            </Route>
            <Route path={`${path}/page/:id`} exact>
                <Pages.NoticeAlarmPage />
            </Route>
        </Switch>
    );

}